import * as React from "react";
import { IBaseFormInputProps } from "../";
import {
    FontAwesomeIcons,
    FontAwesomeIcon,
} from "../../../../constants/fontAwesomeIcons";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment-timezone";
import { DEFAULT_DATE_FORMAT } from "../../../../constants/dateFormats";
import classNames from "classnames";

import "./DatePickerFormInputFabric.scss";

export interface IDatePickerFormInputProps {
    modified?: boolean;
}

const TIMEZONE = "Australia/Sydney";
const dateFormat: string = "YYYY-MM-DD"; // Simple format for component state

class DatePickerFormInputFabric extends React.Component<
    IDatePickerFormInputProps & IBaseFormInputProps
> {
    private container: HTMLDivElement | null = null;

    render() {
        const {
            invalid,
            className,
            value,
            disabled,
            focused,
            hasSoftError,
            hasHardError,
        } = this.props;

        const derivedClassName = className ? className : undefined;

        const date = value
            ? moment.tz(value, TIMEZONE).toDate()
            : null;

        const hardFeedback =
            hasHardError && !disabled ? (
                <span
                    className={classNames("form-control-feedback block pr-8")}
                >
                    <FontAwesomeIcon
                        icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                        fixedWidth
                    />
                </span>
            ) : null;

        const feedback =
            invalid && !disabled && !hasHardError ? (
                <span className={classNames("form-control-feedback pr-8")}>
                    <FontAwesomeIcon
                        icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                        fixedWidth
                    />
                </span>
            ) : null;

        const softFeedback =
            hasSoftError && !disabled && !invalid ? (
                <span
                    className={classNames("form-control-feedback warning pr-8")}
                >
                    <FontAwesomeIcon
                        icon={FontAwesomeIcons.Solid.EXCLAMATION_TRIANGLE}
                        fixedWidth
                    />
                </span>
            ) : null;

        const derivedIsInvalid = invalid && !disabled;
        const derivedIsWarning = hasSoftError && !derivedIsInvalid;
        const derivedIsValid = !derivedIsInvalid && !derivedIsWarning;

        return (
            <div
                ref={(ref) => (this.container = ref)}
                className={classNames(
                    "form-date-group",
                    { focused: focused },
                    { "is-modified": this.props.modified },
                    { "is-invalid": derivedIsInvalid },
                    { "is-valid": derivedIsValid },
                    { "is-warning": derivedIsWarning }
                )}
            >
                <ReactDatePicker
                    selected={date}
                    onChange={this.handleDateChange}
                    dateFormat="dd/MM/yyyy"
                    disabled={disabled}
                    className={derivedClassName}
                    calendarClassName="custom-datepicker-calendar"
                    todayButton="Go to today"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="DD/MM/YYYY"
                    popperProps={{ strategy: "fixed" }}
                />
                <span className="calendar-icon">
                    <FontAwesomeIcon
                        icon={FontAwesomeIcons.Solid.CALENDAR_ALT}
                        fixedWidth
                    />
                </span>
                {invalid && !disabled && (
                    <>
                        {hardFeedback}
                        {softFeedback}
                    </>
                )}
                {feedback}
            </div>
        );
    }

    private handleDateChange = (date: Date | null): void => {
        if (!date) {
            this.props.onChange(null);
        } else {
            const mDate = moment.tz(date, TIMEZONE).startOf('day');
            this.props.onChange(mDate.format(dateFormat));
        }
    };
}

export default DatePickerFormInputFabric;
